import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-brand-black text-white py-1.5 px-3 shadow-md" data-id="element-238">
      <div className="max-w-3xl mx-auto flex flex-row justify-center items-center gap-2 sm:gap-4 text-[11px] sm:text-sm font-bold text-center" data-id="element-239">
        <span className="text-brand-yellow leading-tight" data-id="element-240">⚠️ 66% OFF HOY</span>
        <div className="flex items-center gap-0.5 bg-white/10 px-2 py-0.5 rounded text-[11px] sm:text-sm" data-id="element-241">
          <span className="font-mono" data-id="element-242">{formatTime(timeLeft.hours)}</span>:
          <span className="font-mono" data-id="element-243">{formatTime(timeLeft.minutes)}</span>:
          <span className="font-mono text-brand-yellow" data-id="element-244">
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </div>;
}